import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CreateCustomerInvoiceApi,
  GetStockStatsApi,
  GetCustomerInvoiceApi,
  GetCustomerInvoiceByIdApi,
  getCustomerItemSummaryById,
} from "../../ApiRequests";

export const fetchCustomerItemSummary = createAsyncThunk(
  "fetch/CustomerItemSummary",
  async (id) => {
    try {
      let response;
      response = await getCustomerItemSummaryById(id);
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CustomerItemSummarySlice = createSlice({
  name: "CustomerItemSummary",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerItemSummary.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerItemSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCustomerItemSummary.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CustomerItemSummarySlice.reducer;
